import { QUERY_KEYS } from '../../../../../consts';
import { cloneQuoteService } from '../../../../../services';
import { getAtomWithMutation } from '../../../../../utils';

export const cloneQuoteAtom = getAtomWithMutation({
  mutationKey: QUERY_KEYS.QUOTES.CLONE_QUOTE,
  mutationFn: () => cloneQuoteService,
});
